<template>
  <vs-prompt buttons-hidden title="Order Fulfillment Type" :active="showOrderFulfillmentTypeDialog" @close="close">
    <vs-progress v-if="loading" indeterminate color="primary"></vs-progress>
    <vs-alert title="" :active="error" color="danger">Wasn't able to change order to manual fulfillment!</vs-alert>
    <template v-if="order">
      <div class="vx-row mb-1 p-3">
        Are you sure you want to change fulfillment type for order {{ order.orderNumber }} to {{ order.fulfillmentType === 'auto' ? 'manual' : 'auto' }}?
      </div>
      <div class="vx-row">
        <div class="vx-col w-full my-2">
          <vs-button
            class="float-right"
            color="primary"
            type="border"
            :disabled="loading"
            @click="updateOrderStatus"
          >
            Yes
          </vs-button>
          <vs-button
            class="float-right mr-2"
            color="primary"
            @click="close"
            :disabled="loading"
          >
            No
          </vs-button>
        </div>
      </div>
    </template>
  </vs-prompt>
</template>

<script>
  import api from '@/http/api';

  export default {
    props: [
      'showOrderFulfillmentTypeDialog',
      'order',
      'refresh'
    ],
    data() {
      return {
        loading: false,
        error: false
      }
    },
    methods: {
      async updateOrderStatus() {
        if (this.loading) return;

        this.error = false;
        this.loading = true;

        const data = { fulfillmentType: this.order.fulfillmentType === 'auto' ? 'manual' : 'auto' };
        const result = await api.updateOrder(this.order._id, data);

        this.loading = false;
        if (!result) return this.error = true;

        await this.refresh();
        this.close();
      },
      close() {
        this.error = false;
        this.$emit('update:showOrderFulfillmentTypeDialog', false);
      },
    }
  }
</script>
